export default function ActivityCardBackground() {
  return (
    <div className='absolute left-0 top-0 right-0 bottom-0'>
      <svg
        viewBox='0 0 676 260'
        fill='none'
        className='w-full h-full hidden md:block lg:hidden'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          x='-54.4036'
          y='-138.479'
          width='462'
          height='238.09'
          rx='119.045'
          transform='rotate(70 -54.4036 -138.479)'
          fill='white'
          fillOpacity='0.06'
        />
        <rect
          x='-74.6033'
          y='-132.577'
          width='462'
          height='238.09'
          rx='119.045'
          transform='rotate(60 -74.6033 -132.577)'
          fill='white'
          fillOpacity='0.06'
        />
        <rect
          x='752.292'
          y='-87.4238'
          width='462'
          height='238.09'
          rx='119.045'
          transform='rotate(60 752.292 -87.4238)'
          fill='white'
          fillOpacity='0.06'
        />
        <rect
          x='816.929'
          y='-81.7852'
          width='462'
          height='238.09'
          rx='119.045'
          transform='rotate(70 816.929 -81.7852)'
          fill='white'
          fillOpacity='0.06'
        />
      </svg>
      <svg
        viewBox='0 0 380 527'
        fill='none'
        className='w-full h-full md:hidden lg:block'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          x='-54.4036'
          y='128.021'
          width='462'
          height='238.09'
          rx='119.045'
          transform='rotate(70 -54.4036 128.021)'
          fill='white'
          fillOpacity='0.06'
        />
        <rect
          x='-74.6033'
          y='133.922'
          width='462'
          height='238.09'
          rx='119.045'
          transform='rotate(60 -74.6033 133.922)'
          fill='white'
          fillOpacity='0.06'
        />
        <rect
          x='456.293'
          y='-87.9238'
          width='462'
          height='238.09'
          rx='119.045'
          transform='rotate(60 456.293 -87.9238)'
          fill='white'
          fillOpacity='0.06'
        />
        <rect
          x='520.929'
          y='-82.2852'
          width='462'
          height='238.09'
          rx='119.045'
          transform='rotate(70 520.929 -82.2852)'
          fill='white'
          fillOpacity='0.06'
        />
      </svg>
    </div>
  )
}
